import * as React from "react"
import { useTimeTableColor } from '../../state/storeTimeTableColor';

const SwitchColorPanel = () => {
	const updateShowTextColor = useTimeTableColor(
		( state ) => state.updateShowTextColor
	);
	const ShowTextColor = useTimeTableColor( ( state ) => state.ShowTextColor );

	return (
		<>
			{ ! ShowTextColor ? (
				<button
					className="bg-green-600 px-2 py-2 rounded-md text-white m-2"
					onClick={ () => {
						updateShowTextColor( true );
					} }
				>
					Click To Switch: Now is BackGround
				</button>
			) : (
				<button
					className="bg-blue-600 px-2 py-2 rounded-md text-white m-2"
					onClick={ () => {
						updateShowTextColor( false );
					} }
				>
					Click To Switch: Now is Text
				</button>
			) }
		</>
	);
};

export default SwitchColorPanel;
